import React from "react";

interface PointerIconProps {
  color?: string;
  size?: string | number;
  style?: React.CSSProperties;
  onMouseOver?: React.MouseEventHandler<SVGSVGElement>;
  onMouseOut?: React.MouseEventHandler<SVGSVGElement>;
}

export const PointerIcon: React.FC<PointerIconProps> = ({
  color = "#7a1010",
  size = "25px",
  style,
  onMouseOver,
  onMouseOut,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-0.96 -0.96 33.92 33.92"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      stroke={color}
      strokeWidth="1.6"
      style={{
        display: "block",
        ...style,
      }}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.576"
      />
      <g id="SVGRepo_iconCarrier">
        <title>pin</title>
        <path d="M4 12q0-3.264 1.6-6.016t4.384-4.352 6.016-1.632 6.016 1.632 4.384 4.352 1.6 6.016q0 1.376-0.672 3.2t-1.696 3.68-2.336 3.776-2.56 3.584-2.336 2.944-1.728 2.080l-0.672 0.736q-0.256-0.256-0.672-0.768t-1.696-2.016-2.368-3.008-2.528-3.52-2.368-3.84-1.696-3.616-0.672-3.232zM8 12q0 3.328 2.336 5.664t5.664 2.336 5.664-2.336 2.336-5.664-2.336-5.632-5.664-2.368-5.664 2.368-2.336 5.632z" />
      </g>
    </svg>
  );
};